import React from 'react';
import ScreensTable from './compnents/screens-table/screens-table';

const DeviceScreens: React.FC = () => {
  return (
    <div className="w-full h-full">
      <ScreensTable />
    </div>
  );
};

export default DeviceScreens;
